import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@savgroup-front-common/primitive/ui/drawer';

import { NavigationDrawerLanguageList } from '../NavigationDrawerLanguageList/NavigationDrawerLanguageList';

import messages from './messages';

interface NavigationDrawerLanguageDrawerProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onSelected: () => void;
}

export const NavigationDrawerLanguageDrawer: FC<
  NavigationDrawerLanguageDrawerProps
> = ({ isOpen, onOpenChange, onSelected }) => {
  return (
    <Drawer open={isOpen} onOpenChange={onOpenChange}>
      <DrawerContent data-testid="appBar_drawerLanguageDrawer">
        <DrawerHeader>
          <DrawerTitle>{safeFormattedIntlString(messages.title)}</DrawerTitle>
        </DrawerHeader>

        <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 pb-6">
          <NavigationDrawerLanguageList
            onSelect={() => {
              onOpenChange(false);
              onSelected();
            }}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
